import React from 'react'

const QueryBadge = React.memo(props => {
    return (
        <React.Fragment>
            <span className={'badge badge-secondary'}>{props.children}</span>
        </React.Fragment>
    )
})

export default QueryBadge
